<div>
  <div class="row col-12">
    <div class="col-12 d-flex justify-content-center"></div>
    <h3 class="first col-12  m-b-md"> {{task.division.title ? task.division.title : task.division.name}}: {{
      'DossierBasicInfo.phase.change.from' | translate }}
      {{task.division.phase.description}}. {{ 'DossierBasicInfo.phase.change.to' | translate }}</h3>
    <ng-container *ngIf="taskLoaded()">
      <div class="col-6 m-b-md">
        <p-dropdown [options]="task.work.possiblePhases" optionLabel="description" optionValue="identifier"
          [(ngModel)]="task.work.selectedPhase"></p-dropdown>

      </div>
      <!--
      <div *ngFor="let option of task.work.possiblePhases" class="col-12 mb-2">
        <p-radioButton name="phaseOptions" value="{{ option.identifier }}" label="{{ option.description }}"
          [(ngModel)]="task.work.selectedPhase"></p-radioButton>
      </div>
      -->

    </ng-container>
    <!--span class="col-12 font-bold">Opción seleccionada: {{task.work.selectedOption||'none'}}</span-->
  </div>
</div>